import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import PatternAssignmentIntegerInput from 'samples/plate-maps/pattern-controls/PatternAssignmentIntegerInput';
import PatternDirectionDropdown from 'samples/plate-maps/pattern-controls/PatternDirectionDropdown';
import {PatternAssignmentParameters} from 'samples/plate-maps/PlateMapConstants';

// Looser type for the in progress pattern parameters, allowing for invalid user input
export interface PatternParametersInput extends Omit<
  PatternAssignmentParameters,
  'replicates' | 'startingGroup'
> {
  replicates: number | null;
  startingGroup: number | null;
}

interface AssignWellsByPatternProps {
  patternParams: PatternParametersInput;
  setPatternParams: (params: PatternParametersInput) => void;
}

/**
 * Input parameters for assigning replicate groups to wells on a plate by pattern.
 */
export default function AssignWellsByPattern({
  patternParams,
  setPatternParams,
}: AssignWellsByPatternProps): JSX.Element {
  const {startingGroup, fillDirection, replicates, replicateDirection} = patternParams;

  function onChangeParam(change: Partial<PatternParametersInput>): void {
    setPatternParams({...patternParams, ...change});
  }

  return (
    <div className={css(styles.patternInputs)}>
      <PatternAssignmentIntegerInput
        label="Starting group"
        value={startingGroup}
        onChange={(startingGroup) => {
          onChangeParam({startingGroup});
        }}
      />
      <PatternDirectionDropdown
        label="Fill direction"
        selectedDirection={fillDirection}
        onSelectDirection={(fillDirection) => {
          onChangeParam({fillDirection});
        }}
      />
      <PatternAssignmentIntegerInput
        label="Replicates"
        value={replicates}
        onChange={(replicates) => {
          onChangeParam({replicates});
        }}
      />
      <PatternDirectionDropdown
        label="Replicate direction"
        selectedDirection={replicateDirection}
        onSelectDirection={(replicateDirection) => {
          onChangeParam({replicateDirection});
        }}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  patternInputs: {
    marginTop: 16,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: 16,
  },
});
